import CryptoJS from 'crypto-js';

/**
 * Build a URL for a private uploaded file (tax documents, transaction proofs,
 * dividend CSVs) now served through the API's authenticated file route
 * (API-A5).
 *
 * These files open via plain <a href> / <img src>, which cannot send the
 * accesstoken header, so the admin token is appended as a query parameter.
 * The API verifies the admin session before serving the file.
 *
 * @param {string} filePath  e.g. "public/uploads/tax_documents/"
 * @param {string} fileName  e.g. "abc.pdf"
 * @returns {string} full URL including the admin access token
 */
export const buildSecureFileUrl = (filePath, fileName) => {
    const apiUrl = process.env.REACT_APP_API_URL; // ends with "/"
    const base = `${apiUrl}${filePath}${fileName}`;
    let token = '';
    try {
        const bytes = CryptoJS.AES.decrypt(
            localStorage.getItem('authAdmin'),
            process.env.REACT_APP_ADMIN_TOKEN_SECRET
        );
        const auth = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        token = auth && auth.accesstoken ? auth.accesstoken : '';
    } catch (e) {
        token = '';
    }
    if (!token) return base;
    // Put the token in the URL PATH (not the query string) so Google Analytics
    // cross-domain linking can't strip it. Route: /sf/<token>/<filePath><fileName>
    return `${apiUrl}sf/${encodeURIComponent(token)}/${filePath}${fileName}`;
};

export default buildSecureFileUrl;
